import React from 'react';
import { FormControlLabel, FormHelperText, IconButton, MenuItem, Switch, TextField } from '@material-ui/core';
import { Clear as ClearIcon } from '@material-ui/icons';
import { useFormContext } from '../FormContext';
import ConfigFieldControl from './components/ConfigFieldControl';
import FormConfigTitleDescription from './FormConfigTitleDescription';
import FormConfigRequired from './FormConfigRequired';
const formatOptions = [
    { value: 'phoneNumber', label: 'Phone Number' },
    { value: 'creditcard', label: 'Credit Card' },
    { value: 'format', label: 'Custom Format' }
];
const dataTypeOptions = [
    { value: 'number', label: 'Number' },
    { value: 'string', label: 'String' }
];
export const FormConfigNumberField = () => {
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    const { config = {} } = element;
    const formatValue = config.phoneNumber
        ? 'phoneNumber'
        : config.creditcard
            ? 'creditcard'
            : typeof config.format !== 'undefined'
                ? 'format'
                : '';
    // TODO: update config
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Placeholder', value: (config === null || config === void 0 ? void 0 : config.placeholder) || '', onChange: event => {
                    config.placeholder = event.target.value;
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, type: 'number', variant: 'outlined', label: 'Min', placeholder: 'Enter minimum number value', value: typeof (config === null || config === void 0 ? void 0 : config.min) !== 'undefined' ? config.min : '', onChange: event => {
                    const parsed = parseInt(event.target.value);
                    config.min = isFinite(parsed) ? Math.abs(parsed) : undefined;
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, type: 'number', variant: 'outlined', label: 'Max', placeholder: 'Enter maximum number value', value: typeof (config === null || config === void 0 ? void 0 : config.max) !== 'undefined' ? config.max : '', onChange: event => {
                    const parsed = parseInt(event.target.value);
                    config.max = isFinite(parsed) ? Math.abs(parsed) : undefined;
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', label: 'Format for Masking', placeholder: 'Select format for masking', value: formatValue, onChange: event => {
                    const { value } = event.target;
                    config.phoneNumber = value === 'phoneNumber';
                    config.creditcard = value === 'creditcard';
                    config.format = value === 'format' ? '' : undefined;
                    // if no format, remove mask
                    if (!config.phoneNumber &&
                        !config.creditcard &&
                        typeof config.format === 'undefined') {
                        config.mask = undefined;
                    }
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                }, InputProps: {
                    endAdornment: (React.createElement(IconButton, { onClick: () => {
                            config.phoneNumber = false;
                            config.creditcard = false;
                            config.format = undefined;
                            config.mask = undefined;
                            setFormState(Object.assign({}, formState));
                            notifyFormEdit();
                        } },
                        React.createElement(ClearIcon, null)))
                } }, formatOptions.map((option) => (React.createElement(MenuItem, { key: option.value.toString(), value: option.value }, option.label))))),
        formatValue === 'format' && (React.createElement(React.Fragment, null,
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Custom Format', placeholder: 'Enter format of number (hash based)', value: config.format || '', onChange: event => {
                        config.format = event.target.value;
                        setFormState(Object.assign({}, formState));
                        notifyFormEdit();
                    } }),
                React.createElement(FormHelperText, null, "(e.g. ###-###-##)")))),
        formatValue && (React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Mask', placeholder: 'Show non-entered placed with masked value', value: config.mask || '', onChange: event => {
                    const { value } = event.target;
                    // ignore numbers
                    if (!/\d/.test(value)) {
                        config.mask = event.target.value;
                        setFormState(Object.assign({}, formState));
                        notifyFormEdit();
                    }
                } }),
            React.createElement(FormHelperText, null, "(e.g. _)"))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Prefix', value: (config === null || config === void 0 ? void 0 : config.prefix) || '', onChange: event => {
                    config.prefix = event.target.value;
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Suffix', value: (config === null || config === void 0 ? void 0 : config.suffix) || '', onChange: event => {
                    config.suffix = event.target.value;
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Allow leading zero', control: React.createElement(Switch, { color: 'primary', checked: (config === null || config === void 0 ? void 0 : config.allowLeadingZero) || false, onChange: event => {
                        config.allowLeadingZero = event.target.checked;
                        setFormState(Object.assign({}, formState));
                        notifyFormEdit();
                    } }) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Thousand separator', control: React.createElement(Switch, { color: 'primary', checked: (config === null || config === void 0 ? void 0 : config.thousandSeparator) || false, onChange: event => {
                        config.thousandSeparator = event.target.checked;
                        setFormState(Object.assign({}, formState));
                        notifyFormEdit();
                    } }) })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', label: 'Data Type', value: config.dataType || '', onChange: event => {
                    config.dataType = event.target.value;
                    setFormState(Object.assign({}, formState));
                    notifyFormEdit();
                }, InputProps: {
                    endAdornment: (React.createElement(IconButton, { onClick: () => {
                            config.dataType = undefined;
                            setFormState(Object.assign({}, formState));
                            notifyFormEdit();
                        } },
                        React.createElement(ClearIcon, null)))
                } }, dataTypeOptions.map((option) => (React.createElement(MenuItem, { key: option.value.toString(), value: option.value }, option.label)))))));
};
export default FormConfigNumberField;
//# sourceMappingURL=FormConfigNumberField.js.map